import {
  ShimmeredDetailsListProps,
  Stack,
  SubmissionForm,
  useTheme
} from "@bps/fluent-ui";

import { RolloutPackageFormValues } from "../../rollout/rolloutFormValues";
import {
  SelectSoftwarePackageFormValues,
  SelectSoftwarePackagesFormValues
} from "./selectSoftwarePackageUtils";
import { SelectSoftwarePackageVersionFilter } from "./SelectSoftwarePackageVersionFilter";
import { SelectSoftwarePackageVersionTable } from "./SelectSoftwarePackageVersionTable";

interface SelectSoftwarePackageProps
  extends Pick<ShimmeredDetailsListProps, "selectionMode"> {
  onDismiss: () => void;
  onAdd: (packages: SelectSoftwarePackageFormValues[]) => void;
  rolloutPackages?: RolloutPackageFormValues[];
}

export const SelectSoftwarePackage = ({
  onDismiss,
  onAdd,
  selectionMode,
  rolloutPackages
}: SelectSoftwarePackageProps) => {
  const theme = useTheme();

  return (
    <SelectSoftwarePackageVersionFilter>
      {({ values }) => {
        return (
          <SubmissionForm<SelectSoftwarePackagesFormValues>
            initialValues={{ packages: [] }}
            onSubmit={async values => {
              onAdd(values.packages);
              onDismiss();
            }}
            submitButtonProps={({ state: { values } }) => ({
              text: `Select ${values.packages.length} packages`,
              alwaysEnabled: values.packages.length !== 0
            })}
            cancelButtonProps={{ onClick: onDismiss }}
          >
            {() => {
              return (
                <Stack tokens={{ childrenGap: theme.spacing.m }}>
                  <SelectSoftwarePackageVersionTable
                    selectionMode={selectionMode}
                    filter={values}
                    rolloutPackages={rolloutPackages}
                  />
                </Stack>
              );
            }}
          </SubmissionForm>
        );
      }}
    </SelectSoftwarePackageVersionFilter>
  );
};
